import ImageBlockElement from '@/domain/scene/generic/ImageBlockElement.js'

const PLATFORM_ELEM_NAME = 'Platform'
const PLATFORM_WIDTH_REL = 0.25
const PLATFORM_HEIGHT_REL = 0.12
const PLATFORM_INIT_X_REL = 0
const PLATFORM_INIT_Y_REL = 0.55
const PLATFORM_COLOR = 'rgb(255, 224, 102)'
const PLATFORM_IMG = require('@/assets/platform.png')

const PLATFORM_IMAGE_WIDTH = 2500
const PLATFORM_IMAGE_HEIGHT = 360

export {
  PLATFORM_IMG
}

export default class Platform extends ImageBlockElement {
  constructor () {
    super(
      PLATFORM_ELEM_NAME,
      PLATFORM_WIDTH_REL,
      PLATFORM_HEIGHT_REL,
      PLATFORM_INIT_X_REL,
      PLATFORM_INIT_Y_REL,
      PLATFORM_COLOR,
      PLATFORM_IMG,
      PLATFORM_IMAGE_WIDTH,
      PLATFORM_IMAGE_HEIGHT
    )
  }
}
